import { Button } from '@fox/atoms/src/button/index';
import { Typography } from '@fox/atoms/src/typography/index';
import { useTempDataContext } from '@fox/atoms/src/temp-data-context/index';
import { PaymentMethod, ProviderSelection } from '@fox/finance/src/contracts';
import { FlexColumn, SpaceBetweenRow } from '@fox/layout/src/flex';
import { IQuestionAnswer } from '../../form-root/contracts';
import { useFormRuntimeContext } from '../../form-runtime-context/form-runtime-context';
import { QuestionStyle } from '../../form-runtime-context/contracts';
import { PaymentAnswerData } from './contracts';
import { maskDetails } from './helpers';

interface SavedPaymentDetailsProps {
	labelStyles: Record<string, QuestionStyle>;
	selectedProvider: ProviderSelection;
	parsedAnswer: any;
	questionName: string;
	selectedAnswer: IQuestionAnswer<PaymentAnswerData> | undefined;
}

const SavedPaymentDetails = ({ selectedProvider, labelStyles, parsedAnswer, questionName, selectedAnswer }: SavedPaymentDetailsProps) => {
	const tempDataContext = useTempDataContext();
	const { answerQuestion } = useFormRuntimeContext();
	return (
		<SpaceBetweenRow>
			<FlexColumn style={{ flexBasis: '75%' }}>
				<Typography sx={labelStyles}>Payment details confirmed</Typography>
				{selectedProvider.method === PaymentMethod.DirectDebit ? (
					<FlexColumn>
						{tempDataContext?.debitFormData?.accountName ? (
							<Typography sx={labelStyles}>Account Name: {maskDetails(tempDataContext?.debitFormData?.accountName)}</Typography>
						) : null}
						{tempDataContext?.debitFormData?.accountNumber ? (
							<Typography sx={labelStyles}>Account: {maskDetails(tempDataContext?.debitFormData?.accountNumber)}</Typography>
						) : null}
						{tempDataContext?.debitFormData?.bsb ? (
							<Typography sx={labelStyles}>BSB: {maskDetails(tempDataContext?.debitFormData?.bsb)}</Typography>
						) : null}
					</FlexColumn>
				) : selectedProvider.method === PaymentMethod.CreditCard ? (
					<FlexColumn>
						{tempDataContext?.cardFormData?.cardHolder ? (
							<Typography sx={labelStyles}>Cardholder: {maskDetails(tempDataContext?.cardFormData?.cardHolder)}</Typography>
						) : null}
						{tempDataContext?.cardFormData?.cardNumber ? (
							<Typography sx={labelStyles}>Card Number: {maskDetails(tempDataContext?.cardFormData?.cardNumber)}</Typography>
						) : null}
					</FlexColumn>
				) : null}
			</FlexColumn>

			<Button
				size="small"
				variant="secondary"
				onClick={() => {
					const updatedAnswer = {
						...parsedAnswer,
						intent: undefined,
						success: undefined,
						method: undefined,
						methodId: undefined
					};

					answerQuestion({
						...selectedAnswer,
						answer: {
							answerJson: JSON.stringify(updatedAnswer)
						},
						questionName: questionName
					});
				}}
			>
				Change payment details
			</Button>
		</SpaceBetweenRow>
	);
};

export default SavedPaymentDetails;
